import React from "react";
import {
	EmailShareButton,
	FacebookShareButton,
	InstapaperShareButton,
	LinkedinShareButton,
	TwitterShareButton,
} from "react-share";
import emailIcon from "../../../assets/images/icons/email-icon.svg";
import facebookIcon from "../../../assets/images/icons/icons8-facebook.svg";
import linkedInIcon from "../../../assets/images/icons/icons8-linkedin.svg";
import twitterIcon from "../../../assets/images/icons/icons8-twitter.svg";
import instagramIcon from "../../../assets/images/icons/icons8-instagram.svg";
import { Button } from "../../reusables";
import "./index.scss";

export default function SpecialSectionCard({ data, navigate }) {
	const shareData = [
		{
			image: emailIcon,
			text: "Email",
			path: "/about-us/our-story",
			shareComponent: EmailShareButton,
		},
		{
			image: facebookIcon,
			text: "Facebook",
			path: "/about-us/our-story",
			shareComponent: FacebookShareButton,
		},
		{
			image: linkedInIcon,
			text: "LinkedIn",
			path: "/about-us/our-story",
			shareComponent: LinkedinShareButton,
		},
		{
			image: twitterIcon,
			text: "Twitter",
			path: "/about-us/our-story",
			shareComponent: TwitterShareButton,
		},
		{
			image: instagramIcon,
			text: "Instagram",
			path: "/about-us/our-story",
			shareComponent: InstapaperShareButton,
		},
	];

	return (
		<ul className="">
			{data?.map(({ imageSource, description, name, post }) => (
				<li className="special-section-card">
					<img src={imageSource} alt="" />

					<div className="texts-wrapper">
						<ul>
							{description?.map((desc) => (
								<>
									<li key={desc}>
										<p className="text-justify">{desc}</p>
									</li>
								</>
							))}
						</ul>

						<div>
							<strong>{name}</strong>
							<p>{post}</p>

							<span className="shareText">
								<span className="share">
									Share this content
								</span>

								<div className="subcategories">
									{shareData.map((data) => (
										<data.shareComponent
											className="subcategories_subcategory"
											url={
												"https://3hfoundation.ca/about-us/our-story"
											}
											quote={description[0]}
										>
											<span className="subcategories_subcategory_link">
												<img src={data.image} alt="" />
												<span>{data.text}</span>
											</span>
										</data.shareComponent>
									))}
								</div>
							</span>
						</div>

						{navigate && (
							<div className="mt-3">
								<Button
									transparent
									linkTo="/about-us/our-story"
								>
									Read more
								</Button>
							</div>
						)}
					</div>
				</li>
			))}
		</ul>
	);
}
